var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCutlery(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.9975 14.9999V35.0024H47.4975V54.9974H52.5V5.00244C45.6 5.00244 39.9975 10.5974 39.9975 14.9999ZM27.5025 22.4999H22.5V5.00244H17.4975V22.4999H12.5025V5.00244H7.5V22.4999C7.49975 23.8129 7.75818 25.113 8.26051 26.3261C8.76285 27.5392 9.49925 28.6414 10.4277 29.5698C11.3561 30.4982 12.4583 31.2346 13.6713 31.7369C14.8844 32.2393 16.1845 32.4977 17.4975 32.4974V54.9974H22.5V32.4974C23.813 32.4977 25.1131 32.2393 26.3262 31.7369C27.5392 31.2346 28.6414 30.4982 29.5698 29.5698C30.4983 28.6414 31.2347 27.5392 31.737 26.3261C32.2393 25.113 32.4977 23.8129 32.4975 22.4999V5.00244H27.5025V22.4999Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCutlery);
export default __webpack_public_path__ + "static/media/cutlery.a79472f4d479eaa0c28ece9385f9465b.svg";
export { ForwardRef as ReactComponent };